import React, { Component } from 'react';
import 'antd/dist/antd.css';
import { Form, Select, Button, Upload, message, Row, Col, Input, Modal, Result } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { Spinner } from 'reactstrap';
import axios from '../../utils/request';
import moment from 'moment';
import 'moment/locale/zh-cn';
const { Option } = Select;
moment.locale('zh-cn');
export class MaiRuiBeiDiao extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            showResult: false,
            committing: false,
            committingStyle: "none"
        }
    };
    formRef = React.createRef();
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        let tenantId = urlParams.get("tenantId");
        if (!commonParamater || !tenantId) {
            this.setState({ errorMessage: "参数或tenantId不存在！", isLoading: false, isReady: true });
            return;
        }
        this.setState({
            tenantId: parseInt(tenantId),
            commonParamater
        }) 
        /*let commonParamater = "";
        let tenantId = 601559;*/
        this.validateApplyStatus(parseInt(tenantId), commonParamater, () => {
            //this.validateApplyStatus("commonParamater", () => {
            /*this.setState({
                tenantId: 601559,
                commonParamater: ""
            })*/ 
            this.getDataSource(0, 0, (resdata) => {
                this.setState({
                    source1: resdata,
                    bDMethod: 1,
                    source2: [],
                    source3: [],
                    source4: [],
                    FilePath: []
                });
                this.getDataSource(0, 1, (resdatax) => {
                    this.setState({
                        source4: resdatax
                    });
                });
            });
        });
    };

    uploadProps = {
        maxCount: 10,
        name: 'formFile',
        action: '/api/MaiRui/UploadFile',
        multiple: true,
        onChange: info => {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                var _arr = this.state.FilePath;
                _arr.push(JSON.parse(JSON.parse(info.file.xhr.response).data).dfsPath);
                this.setState({
                    FilePath: _arr
                });
                message.success(`${info.file.name} 附件上传成功`);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} 附件上传失败.`);
            }
        }, onRemove: file => {
            var _file = JSON.parse(file.response.data).dfsPath;
            var _arr = this.state.FilePath.filter(x => x != _file);
            this.setState({
                FilePath: _arr
            });
        }
    }
    beforeUpload = (file) => {
        const isLt5M = file.size / 1024 / 1024 < 5; 
        if (!isLt5M) {
            message.error('文件最大不能超过5MB!');
            return isLt5M || Upload.LIST_IGNORE;
        }
        var _arr = ["application/msword","application/vnd.openxmlformats-officedocument.spreadsheetml.sheet","application/pdf", "image/png", "image/jpeg", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
        const isLmtExt = _arr.indexOf(file.type) > -1;
        if (!isLmtExt) {
            message.error('不支持该文件类型!');
            return isLmtExt || Upload.LIST_IGNORE;
        }
        const isLmtCount = this.state.FilePath.length < 10;
        if (!isLmtCount) {
            message.error('最多上传10条报告文件!');
            return isLmtCount || Upload.LIST_IGNORE;
        }
    }
    validateApplyStatus = (tenantId, commonParamater, func) => {
        const params = {
            tenantId,
            commonParamater
        }
        axios.get("/api/MaiRui/ValidateApplyStatus", { params: params }).then(res => {
            const isSuccessValue = res.data.code == "200";
            if (!isSuccessValue) {
                this.setState({ isLoading: false, isReady: true, errorMessage: res.data.message, showResult: true });
            } else {
                this.setState({ userId: JSON.parse(res.data.data).UserId, mode: JSON.parse(res.data.data).Mode, applyIds: JSON.parse(res.data.data).ApplyIds });
                func();
            }
        })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };
    getDataSource = (bDMethod, sourceType, func) => {
        const params = {
            mode: this.state.mode,
            tenantId: this.state.tenantId,
            userId: this.state.userId,
            bDMethod,
            sourceType
        }
        axios.get("/api/MaiRui/getDataSource", { params: params }).then(res => {
            const isSuccessValue = res.data.code == "200";
            let resdata = res.data.data;
            let errorMessage = "";
            if (!isSuccessValue) {
                errorMessage = "初始化失败！" + res.data.message
            } else {
                if (resdata !== "") {
                    errorMessage = "";
                    func(resdata);
                } else {
                    errorMessage = "初始化失败！";
                }
            }
            this.setState({ isLoading: false, isReady: true, errorMessage });
        })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };
    selectChange = (value) => {
        this.formRef.current.resetFields(["source3", "source2", "source4"]);
        if (value !== null && value !== "") {
            this.setState({
                bDMethod: value
            });
            if (value != 0) {
                this.getDataSource(value, 1, (resdata) => {
                    this.setState({
                        source2: resdata
                    });
                });
                this.getDataSource(value, 2, (resdata) => {
                    this.setState({
                        source3: resdata
                    });
                });
            } else {
                this.getDataSource(value, 1, (resdata) => {
                    this.setState({
                        source4: resdata
                    });
                });
            }
        }
    }
    handleOk = values => {
        if (this.state.committing) {
            return;
        }
        let _this = this.state;
        let tenantId = _this.tenantId;
        const params = {
            bdMethod: parseInt(_this.formValues.source1),
            tenantId,
            submitDto: {
                PackageId: _this.formValues.source2 ?? "",
                ExtraItems: _this.formValues.source3 ?? [],
                BdResult: _this.formValues.source4 == undefined ? 0 : parseInt(_this.formValues.source4),
                Remarks: _this.formValues.remark ?? "",
                FilePath: _this.FilePath ?? [],
                ApplyIds: _this.applyIds,
                UserId: _this.userId
            }
        }
        console.log(params);
        const bodyString = JSON.stringify(params);
        this.setState({ committing: true, committingStyle: "block" });
        axios.post("/api/MaiRui/CreateOrder", bodyString,
            {
                headers: { "Content-Type": "application/json" }
            })
            .then(res => {
                const isSuccessValue = res.data.code == "200";
                const resback = res.data.message;
                let errorMessage = "";
                if (!isSuccessValue) {
                    errorMessage = "失败原因：" + resback
                }
                this.setState({
                    isLoading: false, isReady: true, errorMessage, showResult: true, committing: false, committingStyle: "none"
                });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！", committing: false, committingStyle: "none" });
            })
            .finally(
            );
    }
    showModal = values => {

        this.setState({ showconfirm: true, formValues: values });
    }
    handleCancel = values => {
        this.setState({ showconfirm: false });
    }
    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "" && !this.state.showResult) {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else if (this.state.showResult && this.state.errorMessage == "") {
                return (<Result
                    status="success"
                    title="提交成功!"
                    //subTitle="已成功发起背调，请关注进展！"
                    subTitle={this.state.bDMethod == 0 ? "已上传自行背调报告" : "背调已发起，如需撤销请登录对应的背调供应商系统进行撤销操作"}
                />)
            }
            else if (this.state.showResult && this.state.errorMessage != "") {
                return (
                    <div>
                        <Result
                            status="warning"
                            title="发起背调失败"
                        />
                        <span dangerouslySetInnerHTML={{ __html: this.state.errorMessage }}></span>
                    </div>
                )
            }
            else {
                return (
                    <div style={{ margin: "32px auto", maxWidth: "1000px" }}>
                        <Form onFinish={this.showModal} ref={this.formRef} layout="vertical" labelCol={{ span: 20 }} wrapperCol={{ span: 20 }}  >
                            <Row>
                                <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                                    <Form.Item label="背调方式" name="source1"
                                        rules={[
                                            {
                                                required: true,
                                                message: "背调方式不能为空！"
                                            }
                                        ]}>
                                        <Select
                                            showSearch
                                            onChange={this.selectChange}
                                            placeholder="请选择">
                                            {this.state.source1.map(el => (
                                                <Option value={el.value}  >{el.text}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col hidden={this.state.bDMethod == 0} xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                                    <Form.Item label="背调套餐" name="source2"
                                        rules={[
                                            {
                                                required: this.state.bDMethod != 0,
                                                message: "背调套餐不能为空！"
                                            }
                                        ]}>
                                        <Select showSearch
                                            placeholder="请选择"
                                        >
                                            {this.state.source2.map((el) => (
                                                <Option value={el.value}  >{el.text}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col hidden={this.state.bDMethod != 0} xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                                    <Form.Item label="自行背调报告" name="reports"
                                        rules={[
                                            {
                                                required: this.state.bDMethod == 0,
                                                message: "背调报告必须上传！"
                                            }
                                        ]}>
                                        <Upload beforeUpload={(file) => this.beforeUpload(file)} data={{ tenantid: this.state.tenantId }} {...this.uploadProps} accept=".pdf,.doc,.docx,.jpg,jpeg,.png,.xls,.xlsx">
                                            <Button icon={<UploadOutlined />}>上传</Button>
                                        </Upload>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col hidden={this.state.bDMethod == 0} xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                                    <Form.Item label="附加项" name="source3" >
                                        <Select showSearch mode="multiple"
                                            placeholder="请选择"
                                        >
                                            {this.state.source3.map((el) => (
                                                <Option value={el.value}  >{el.text}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col hidden={this.state.bDMethod != 0} xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}>
                                    <Form.Item label="背调结果" name="source4"
                                        rules={[
                                            {
                                                required: this.state.bDMethod == 0,
                                                message: "背调结果不能为空！"
                                            }
                                        ]}>
                                        <Select showSearch placeholder="请选择">
                                            {this.state.source4.map((el) => (
                                                <Option value={el.value}  >{el.text}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }}  >
                                    <Form.Item label="备注" name="remark" >
                                        <Input maxLength="500" defaultValue={this.state.stfCode} value={this.state.stfCode} ></Input>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <div>
                                <Modal title="发起背调" visible={this.state.showconfirm} onOk={this.handleOk} onCancel={this.handleCancel} disabled={!this.state.committing} cancelText="取消" okText="发送">
                                    <p>确定发起背调？</p>
                                    <div style={{ textAlign: "center", display: this.state.committingStyle }}>
                                        <Spinner type="grow" color="primary" />
                                        <Spinner type="grow" color="secondary" />
                                        <Spinner type="grow" color="success" />
                                        <Spinner type="grow" color="danger" />
                                        <Spinner type="grow" color="warning" />
                                        <Spinner type="grow" color="info" />
                                        <Spinner type="grow" color="dark" />
                                    </div>
                                </Modal>
                            </div>
                            <Row>
                                <Col xs={{ span: 4, offset: 20 }} md={{ span: 4, offset: 20 }} lg={{ span: 4, offset: 20 }}>
                                    <br />
                                    <Button type="primary" htmlType="submit" > 保存</Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                );
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}